export default "__VITE_ASSET__CYUhP$ly__"